import { RegexPattern } from './regexValidation.type';

export const regexPatterns: Record<
string,
(errorMessage?: string) => RegexPattern
> = {
  lettersOnly: (errorMessage = 'Dozwolone znaki to litery') => ({
    value: /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]+$/,
    message: errorMessage,
  }),

  lettersSpacesDashes: (
    errorMessage = 'Dozwolone znaki to litery, spacja oraz myślnik',
  ) => ({
    value: /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ -]+$/,
    message: errorMessage,
  }),

  lettersSpacesDashesDots: (
    errorMessage = 'Dozwolone znaki to litery, spacja, kropka oraz myślnik',
  ) => ({
    value: /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ. -]+$/,
    message: errorMessage,
  }),

  numbersOnly: (errorMessage = 'Dozwolone znaki to cyfry') => ({
    value: /^[0-9]+$/,
    message: errorMessage,
  }),

  postalCode: (errorMessage = 'Błędny kod pocztowy') => ({
    value: /^\d{2}-\d{3}$/,
    message: errorMessage,
  }),
};
